import { UserManager } from 'oidc-client-ts'
import { oidcSettings } from './oidcConfig'

/**
 * Tek paylaşılan {@link UserManager} örneği. Hem `react-oidc-context` AuthProvider'ı bunu kullanır
 * hem de React-dışı katman (axios interceptor — `client.ts`) aktif access-token'ı buradan okur; böylece
 * token durumu tek kaynaktır (aynı localStorage store).
 */
export const userManager = new UserManager(oidcSettings)

/** Aktif access-token (yoksa null). Süresi dolmuşsa kütüphane sessiz yenileme yönetir. */
export async function getAccessToken(): Promise<string | null> {
  const user = await userManager.getUser()
  return user?.access_token ?? null
}
